<ngx-spinner [fullScreen]="true" bdColor="rgba(51,51,51,0.9)" size="large" color="#fff" type="ball-clip-rotate">
</ngx-spinner>

<ngx-ui-loader></ngx-ui-loader>

<router-outlet></router-outlet>